<section class="signup">
  <div class="panel panel-hero">
    <div class="pre-head">
      <mat-icon svgIcon="logo-rebillia" class="custom-mat-icon ico-isologo-login"></mat-icon>
    </div>
    <div class="panel-header slide__right">
      <div class="panel-wrapper">
        <h1 class="typo headline semi-condensed fw300 label-title">Get started with a free account</h1>
        <p class="typo body-1 semi-condensed fw300 label-subtitle">Know your customers. Engage your customers. Do it all with Rebillias’s subscription platform. <a [routerLink]="['/login/signin']" class="typo fw500 custom-mat-link active">Already have an account?</a></p>
      </div>
    </div>
    <div class="panel-main">
      <form [formGroup]="form" class="panel-wrapper" novalidate>
        <ul>
          <li class="row-form row-message">
            <section class="message message-login" [@messageAnimation]='messageStatus'>
              <div class="message-wrapper error">
                <mat-icon svgIcon="ico-error" class="custom-mat-icon message-icon ico-size ico-sm"></mat-icon>
                <p *ngIf="errCode == 400" class="message-description">Please check your entry and try again.</p>
              </div>
              <div class="message-wrapper error">
                <p *ngIf="errCode == 400" class="message-description">{{errMessage}}</p>
              </div>
            </section>
          </li>
          <li class="row-form row__below__message" style="margin-bottom: 14px;">
            <mat-form-field appearance="outline" class="size size1of1">
              <mat-label>First name</mat-label>
              <input matInput placeholder="First name" color="accent" formControlName="firstName" required >
              <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('firstName')"></error-messages></mat-error>
            </mat-form-field>
          </li>
          <li class="row-form margin" style="margin-bottom: 14px;">
            <mat-form-field appearance="outline" class="size size1of1">
              <mat-label>Last name</mat-label>
              <input matInput placeholder="Last name" color="accent" formControlName="lastName" required>
              <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('lastName')"></error-messages></mat-error>
            </mat-form-field>
          </li>
          <li class="row-form margin" style="margin-bottom: 14px;">
            <mat-form-field appearance="outline" class="size size1of1">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" color="accent" formControlName="email" required>
              <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('email')"></error-messages></mat-error>
            </mat-form-field>
          </li>
          <li class="row-form margin nomargin">
            <mat-form-field appearance="outline" class="size size1of1">
              <mat-label>Password</mat-label>
              <input matInput type="password" placeholder="Password" formControlName="password" required [type]="hide ? 'password' : 'text'">
              <mat-error style="margin-top: 16px;"><error-messages [control]="form.get('password')"></error-messages></mat-error>
              <mat-icon matSuffix (click)="hide = !hide">{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
            </mat-form-field>
          </li>
          <li class="row-form row-nav align center">
            <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted || enableCreateCompanyButton" ngClass="{'is--loading': formSubmitted}" color="primary" class="custom-mat-button-primary size size1of1 rounded" >Sign Up</button>
          </li>
          <li class="row-form align center">
            <mat-list class="custom-mat-list list-simple-nav">
              <mat-list-item class="custom-mat-list-item aside">
                <a [routerLink]="['/login/signin']" routerLinkActive="router-link-active" class="custom-mat-link hasIco active">
                  <mat-icon svgIcon="ico-back" class="custom-mat-icon ico-size ico-3xs"></mat-icon>
                  <span class="ico-label">Back to sign in</span>
                </a>
              </mat-list-item>
            </mat-list>
          </li>
          <li class="row-copyright">
            <p class="typo note semi-condensed fw300 fluid-max max-200">By clicking sign up, you agree to Rebillia's
              <strong class="typo fw600">Privacy Policy</strong> and <strong class="typo fw600">Terms of Use</strong>.</p>
          </li>
        </ul>
      </form>
    </div>
  </div>
</section>
